module.exports = __webpack_public_path__ + "img/r2l8内六角螺丝.SLDPRT.53c8cc1a.jpg";